/* Mobile Sticky Toolbar — static behaviour (cached by the CDN across all pages)
 *
 * مبادئ الأداء المتّبعة هنا:
 *   - مفيش setInterval ولا polling خالص
 *   - مفيش تعديل على window.fetch
 *   - عداد السلة بيتقرأ من #cart-icon-bubble اللي Dawn بيعمله re-render أصلاً → صفر requests
 *   - المراقبين (observers) و listener السكرول singletons مشتركين، مش نسخة لكل تولبار
 *   - المراقبين بيتفصلوا تلقائياً لما مايبقاش فيه تولبار محتاجهم
 */
(function () {
  'use strict';

  if (window.__mtbBooted) return;
  window.__mtbBooted = true;

  /* الكلاسات اللي Dawn (أو المنيو المخصص) بيحطها على body لما يفتح overlay */
  var LOCK_CLASSES = ['overflow-hidden', 'blur-menu-open'];

  var instances = [];

  function firstVisible(selector) {
    var list = document.querySelectorAll(selector);
    for (var i = 0; i < list.length; i++) {
      if (list[i].getClientRects().length > 0) return list[i];
    }
    return null;
  }

  function removeFrom(arr, item) {
    var i = arr.indexOf(item);
    if (i > -1) arr.splice(i, 1);
  }

  /* =========================================================
     1) مراقب الـ overlay — نسخة واحدة مشتركة
     ========================================================= */
  var overlaySubs = [];
  var overlayState = false;
  var overlayObservers = [];

  function isOverlayOpen() {
    var cl = document.body.classList;
    for (var i = 0; i < LOCK_CLASSES.length; i++) {
      if (cl.contains(LOCK_CLASSES[i])) return true;
    }
    var drawer = document.querySelector('cart-drawer');
    return !!(drawer && drawer.classList.contains('active'));
  }

  function syncOverlay() {
    var open = isOverlayOpen();
    if (open === overlayState) return;
    overlayState = open;
    for (var i = 0; i < overlaySubs.length; i++) overlaySubs[i](open);
  }

  function subscribeOverlay(fn) {
    overlaySubs.push(fn);
    if (overlayObservers.length === 0) {
      var bodyObs = new MutationObserver(syncOverlay);
      bodyObs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      overlayObservers.push(bodyObs);

      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        var drawerObs = new MutationObserver(syncOverlay);
        drawerObs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
        overlayObservers.push(drawerObs);
      }
      overlayState = isOverlayOpen();
    }
    fn(overlayState);

    return function () {
      removeFrom(overlaySubs, fn);
      if (overlaySubs.length === 0) {
        overlayObservers.forEach(function (o) {
          o.disconnect();
        });
        overlayObservers = [];
      }
    };
  }

  /* =========================================================
     2) مراقب السكرول — نسخة واحدة مشتركة
     ========================================================= */
  var scrollSubs = [];
  var scrollState = false;
  var scrollAttached = false;
  var lastY = 0;
  var ticking = false;

  function onScrollFrame() {
    ticking = false;
    var y = window.pageYOffset || 0;
    var delta = y - lastY;
    if (Math.abs(delta) < 8) return;
    var atBottom = window.innerHeight + y >= document.documentElement.scrollHeight - 60;
    var next = delta > 0 && y > 120 && !atBottom;
    lastY = y;
    if (next === scrollState) return;
    scrollState = next;
    for (var i = 0; i < scrollSubs.length; i++) scrollSubs[i](next);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(onScrollFrame);
  }

  function subscribeScroll(fn) {
    scrollSubs.push(fn);
    if (!scrollAttached) {
      lastY = window.pageYOffset || 0;
      window.addEventListener('scroll', onScroll, { passive: true });
      scrollAttached = true;
    }
    return function () {
      removeFrom(scrollSubs, fn);
      if (scrollSubs.length === 0 && scrollAttached) {
        window.removeEventListener('scroll', onScroll);
        scrollAttached = false;
        scrollState = false;
      }
    };
  }

  /* =========================================================
     3) عداد السلة — نسخة واحدة مشتركة، صفر requests
     ========================================================= */
  var cartSubs = [];
  var cartObserver = null;
  var cartBubble = null;
  var cartFallbackOffs = [];
  var cartTimer = null;

  function readBubble() {
    if (!cartBubble) return null;
    var wrap = cartBubble.querySelector('.cart-count-bubble');
    if (!wrap) return 0;
    var visible = wrap.querySelector('span[aria-hidden="true"]');
    if (visible) {
      var n = parseInt(visible.textContent.trim(), 10);
      if (!isNaN(n)) return n;
    }
    return 100; // Dawn بيخفي الرقم فوق 99
  }

  function emitCount(count) {
    if (count === null) return;
    for (var i = 0; i < cartSubs.length; i++) cartSubs[i](count);
  }

  function subscribeCart(fn, cartUrl) {
    cartSubs.push(fn);

    if (cartSubs.length === 1) {
      cartBubble = document.getElementById('cart-icon-bubble');

      if (cartBubble) {
        /* Dawn بيعمل re-render للأيقونة دي مع كل تغيير في السلة
           عن طريق Section Rendering API → بنقرأ منها بدل ما نطلب /cart.js */
        cartObserver = new MutationObserver(function () {
          emitCount(readBubble());
        });
        cartObserver.observe(cartBubble, {
          childList: true,
          subtree: true,
          characterData: true
        });
      } else {
        /* fallback: بس لو مفيش أيقونة سلة في الهيدر خالص */
        var refresh = function () {
          clearTimeout(cartTimer);
          cartTimer = setTimeout(function () {
            fetch(cartUrl, { headers: { Accept: 'application/json' } })
              .then(function (r) {
                return r.json();
              })
              .then(function (c) {
                emitCount(c.item_count);
              })
              .catch(function () {});
          }, 400);
        };

        ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (name) {
          document.addEventListener(name, refresh);
          cartFallbackOffs.push(function () {
            document.removeEventListener(name, refresh);
          });
        });

        var onSubmit = function (e) {
          var form = e.target;
          if (form && form.action && form.action.indexOf('/cart') !== -1) refresh();
        };
        document.addEventListener('submit', onSubmit, true);
        cartFallbackOffs.push(function () {
          document.removeEventListener('submit', onSubmit, true);
        });
      }
    }

    if (cartBubble) fn(readBubble());

    return function () {
      removeFrom(cartSubs, fn);
      if (cartSubs.length === 0) {
        if (cartObserver) {
          cartObserver.disconnect();
          cartObserver = null;
        }
        clearTimeout(cartTimer);
        cartFallbackOffs.forEach(function (off) {
          off();
        });
        cartFallbackOffs = [];
        cartBubble = null;
      }
    };
  }

  /* =========================================================
     4) تهيئة تولبار واحد
     ========================================================= */
  function init(toolbar) {
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].el === toolbar) return;
    }

    var offs = [];
    var state = { scroll: false, overlay: false };
    var frame = null;

    function apply() {
      frame = null;
      toolbar.classList.toggle('is-hidden', state.scroll || state.overlay);
    }
    function schedule() {
      if (frame === null) frame = requestAnimationFrame(apply);
    }

    /* --- إخفاء عند فتح أي overlay --- */
    offs.push(
      subscribeOverlay(function (open) {
        if (open === state.overlay) return;
        state.overlay = open;
        schedule();
      })
    );

    /* --- إخفاء عند النزول (اختياري) --- */
    if (toolbar.getAttribute('data-mtb-scroll-hide') === 'true') {
      offs.push(
        subscribeScroll(function (hidden) {
          if (hidden === state.scroll) return;
          state.scroll = hidden;
          schedule();
        })
      );
    }

    /* --- عداد السلة --- */
    var badges = toolbar.querySelectorAll('[data-mtb-cart-badge]');
    if (badges.length) {
      var setCount = function (count) {
        for (var b = 0; b < badges.length; b++) {
          var badge = badges[b];
          if (!count || count < 1) {
            badge.classList.add('is-hidden');
            continue;
          }
          badge.classList.remove('is-hidden');
          var label = count > 99 ? '99+' : String(count);
          if (badge.textContent !== label) {
            badge.textContent = label;
            badge.classList.remove('is-bump');
            void badge.offsetWidth;
            badge.classList.add('is-bump');
          }
        }
      };

      offs.push(subscribeCart(setCount, toolbar.getAttribute('data-mtb-cart-url') || '/cart.js'));

      var onPageShow = function (e) {
        if (e.persisted) {
          var c = readBubble();
          if (c !== null) setCount(c);
        }
      };
      window.addEventListener('pageshow', onPageShow);
      offs.push(function () {
        window.removeEventListener('pageshow', onPageShow);
      });
    }

    /* --- السلة / البحث / المنيو --- */
    function onClick(e) {
      var cartBtn = e.target.closest('[data-mtb-cart-drawer]');
      if (cartBtn) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          e.preventDefault();
          drawer.open(cartBtn);
        }
        /* لو مفيش درور → اللينك بيروح /cart عادي */
        return;
      }

      var searchBtn = e.target.closest('[data-mtb-search]');
      if (searchBtn) {
        var summary =
          firstVisible('.header__search summary, details-modal.header__search summary') ||
          firstVisible('.header details-modal summary') ||
          firstVisible('.header__icon--search');
        if (summary) {
          e.preventDefault();
          var details = summary.closest('details');
          if (details && details.hasAttribute('open')) return;
          /* مهم: Dawn بيسجّل listener على body جوه open() بيقفل المودال لو الضغطة من بره.
             لازم الضغطة الأصلية تخلص رحلتها الأول، عشان كده بنأجّل تيك واحد. */
          setTimeout(function () {
            summary.click();
          }, 0);
        }
        return;
      }

      var menuBtn = e.target.closest('[data-mtb-menu]');
      if (menuBtn) {
        var trigger =
          firstVisible('[data-blur-menu-trigger]') ||
          document.querySelector('[data-blur-menu-trigger]') ||
          firstVisible('.header__icon--menu');
        if (trigger) {
          e.preventDefault();
          setTimeout(function () {
            trigger.click();
          }, 0);
        }
      }
    }

    toolbar.addEventListener('click', onClick);
    offs.push(function () {
      toolbar.removeEventListener('click', onClick);
    });

    /* --- مساحة تحت المحتوى بالارتفاع الحقيقي --- */
    if (toolbar.getAttribute('data-mtb-spacing') === 'true' && 'ResizeObserver' in window) {
      var ro = new ResizeObserver(function (entries) {
        var h = entries[0].target.offsetHeight;
        if (h > 0) document.documentElement.style.setProperty('--mtb-height-actual', h + 'px');
      });
      ro.observe(toolbar);
      offs.push(function () {
        ro.disconnect();
        document.documentElement.style.removeProperty('--mtb-height-actual');
      });
    }

    instances.push({ el: toolbar, offs: offs });
  }

  function disposeInstance(inst) {
    inst.offs.forEach(function (off) {
      try {
        off();
      } catch (err) {}
    });
  }

  function cleanupDetached() {
    for (var i = instances.length - 1; i >= 0; i--) {
      if (!document.contains(instances[i].el)) {
        disposeInstance(instances[i]);
        instances.splice(i, 1);
      }
    }
  }

  function initAll() {
    cleanupDetached();
    var nodes = document.querySelectorAll('[data-mobile-toolbar]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  /* Theme Editor */
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', cleanupDetached);
})();
